<template>
  <component
    :is="objectLink && hasAnyPermission('OBJECT_VIEW_DETAILS') ? 'router-link' : 'placeholder-component'"
    :to="objectLink"
    :target="openInNewTab ? '_blank' : '_self'"
    class="object-group-name"
    :title="displayName"
  >
    {{ displayName }}
  </component>
</template>

<script>
import {MainUtils} from '../utils/main-utils';
import {LocaleUtils} from '@/utils/locale-utils';
import PlaceholderComponent from '@/components/PlaceholderComponent';

export default {
  name: 'ObjectGroupName',
  components: {
    PlaceholderComponent
  },
  mixins: [
    MainUtils,
    LocaleUtils
  ],
  props: {
    value: {
      required: true
    },
    openInNewTab: {
      default () {
        return true;
      }
    }
  },
  computed: {
    isObjectProvided() {
      return this.value != null && typeof this.value === 'object';
    },
    displayName() {
      return this.isObjectProvided ? this.value.name : this.value;
    },
    objectGroupId() {
      return this.isObjectProvided ? this.value.id : null;
    },
    objectLink() {
      if (this.objectGroupId == null) {
        return null;
      }

      return {
        name: 'ObjectGroupPage',
        params: {
          objectGroupId: this.objectGroupId
        }
      }
    }
  }
}
</script>

<style scoped>
.object-group-name {
  display: inline-block;
}

.object-group-name:hover .more-icon {
  opacity: 1 !important;
}
</style>
